import { useRouteHandleFlag } from "web_myplann/Shared/Hooks/useRouteHandleFlag";

export const useIsNavbarRoot = () => useRouteHandleFlag("showNavbar");
